<script setup lang="ts">
import { tpgIconPermMedia } from '@tpg/grammar-web-icons';
import { useDebounceFn } from '@vueuse/core';

import type { GrammarMenuItemProps } from '@nora-monorepo/grammar-ui';

import MenuItemRow from '#nora-ui/map/components/overlay-menu/primitives/MenuItemRow.vue';
import { useMapStore } from '#nora-ui/map/stores/map-store';

interface FileLayerMenuItemProps {
  mapId: string;
}

const props = defineProps<FileLayerMenuItemProps>();

const mapStore = useMapStore();

const map = mapStore.getMapByIdOrThrow(props.mapId);

function onFileLayerVisibilityChanged() {
  map.state.file.toggleVisibility();
}

function onToggleClusterFilesClick() {
  map.layers.file.toggleClustering();
}

const menuItems: GrammarMenuItemProps[] = [
  {
    label: 'Toggle cluster',
    onSelect: useDebounceFn(onToggleClusterFilesClick, 100),
  },
];
</script>

<template>
  <MenuItemRow
    title="Files"
    :icon="tpgIconPermMedia"
    :menu-items="menuItems"
    :visible="map.state.file.fileLayerVisible"
    @visibility-changed="onFileLayerVisibilityChanged"
  />
</template>
